import React from 'react';
import { buildObjectsArr } from '../../helper/helper.js'
import { Segment, Container, Divider, Input, Button, Table, Dropdown } from 'semantic-ui-react';

class AdmDBBrowser extends React.Component {
  constructor() {
    super();

    this.renderItemTable = this.renderItemTable.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);

    this.state = {
      query: '',
      queryKey: ''
    }
  }

  componentWillMount() {
    const { queryKey = 'name'} = this.props;
    this.setState({queryKey});
  }

  renderItemTable(obj, index) {
    return (
      <Table unstackable celled fixed striped key={index}
        onClick={() => this.props.selectObj(obj)} >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan={2}>{obj.key}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {Object.keys(obj).map((el, i) =>
            <Table.Row key={i}>
              <Table.Cell>{el+':'}</Table.Cell>
              <Table.Cell>{JSON.stringify(obj[el])}</Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    )
  }

  handleSearchChange = (e, {value}) => {
    this.setState({
      query: value,
    })
  }

  render() {
    //Transforming the endpointData into an array of objects and adding the key property
    const endpointData = buildObjectsArr(this.props.endpointData);

    //generate dropdown options from passed in object keys
    let options = [];
    if(endpointData.length) {
      options = Object.keys(endpointData[0]).map(key => {
        return {'key': key, 'text': key, 'value': key}
      });
    }

    //filter execution
    let displayData = [...endpointData];
    if(this.state.query) {
      displayData = displayData.filter( el =>
        el[this.state.queryKey].toLowerCase()
        .includes(this.state.query.toLowerCase())
      );
    }

    return (
      <Segment loading={this.props.loading} >
        <Button fluid size='large' icon='plus' content='Add New Item'
          onClick={() => this.props.setKeyEditable(true)} />
        <Divider />
        <Input
          className='icon searchBar fluid'
          placeholder='Filter by Name...'
          value={this.state.query}
          onChange={this.handleSearchChange}
          labelPosition='right'
          label={
            <Dropdown basic loading={this.props.loading}
              options={options} defaultValue={this.state.queryKey}
              onChange={(e,{value}) => this.setState({queryKey: value})} />
            }/>
        <Divider />
        <Container className='itemTableList'>
          { displayData.map((el, i) => this.renderItemTable(el, i)) }
        </Container>
      </Segment>
    );
  }

}

export default AdmDBBrowser;



// WEBPACK FOOTER //
// ./src/components/protected/AdmDBBrowser.js